(function () {
  window.shReveal = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;

  var sticky = document.querySelector('[data-sh-sticky]');
  var first = document.querySelector('main > .shopify-section');
  if (sticky) {
    sticky.removeAttribute('hidden');
    if (first && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        sticky.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }, { threshold: 0, rootMargin: '-25% 0px 0px 0px' }).observe(first);
    }
  }

  document.querySelectorAll('main product-card').forEach(function (el, i) {
    el.setAttribute('data-sh-reveal', '');
    el.style.setProperty('--d', i % 4);
  });

  var items = document.querySelectorAll('[data-sh-reveal]');
  function show(el) { el.classList.add('is-in'); }
  if (reduce || design || !('IntersectionObserver' in window)) { items.forEach(show); return; }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      show(el);
      io.unobserve(el);
      window.setTimeout(function () { el.style.transitionDelay = '0ms'; }, 700);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  items.forEach(function (el) { io.observe(el); });

  items.forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) { show(el); io.unobserve(el); }
  });
})();
